import { tx } from '@transifex/native'

import { getEnvironmentVariable } from './helpers/environment'

const token = getEnvironmentVariable('transifexToken')

tx.init({
  token,
})
